import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ItemMenu from './ItemMenu.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['collapsed'],
  setup(__props) {


const router = useRouter()
const routerArr = router.options.routes // 获取所有路由信息用于渲染主菜单
const currentRoute = useRoute() // 当前路由
const selectedKeys = computed(() => {
  const arr: string[] = []
  currentRoute.matched.forEach(el => {
    arr.push(el.path)
  });
  return arr
})
const openKeys = computed(() => {
  const arr: string[] = []
  currentRoute.matched.forEach(el => {
    arr.push(el.path)
  });
  return arr
})


return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(_component_a_menu, {
    id: "menu-div",
    openKeys: _unref(openKeys),
    selectedKeys: _unref(selectedKeys),
    style: _normalizeStyle({ 'width': __props.collapsed ? '80px' : '220px', 'height': '100%', 'font-size': '16px' ,'background':'#0f5abe','color':'#ffffff'}),
    mode: "inline",
    "inline-collapsed": __props.collapsed
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routerArr), (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(ItemMenu, {
            item: item,
            basePath: item.path
          }, null, 8, ["item", "basePath"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["openKeys", "selectedKeys", "style", "inline-collapsed"]))
}
}

})